export const footerLinks = {
    'mx-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://mx.wingie.com/vuelos/a-mexico-city/',
                    title: 'México City',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/a-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/a-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/a-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/a-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/a-los-angeles/',
                    title: 'Los Ángeles',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://mx.wingie.com/vuelos/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/ca-canada/',
                    title: 'Canadá',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/co-colombia/',
                    title: 'Colombia',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/es-espana/',
                    title: 'España',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/vuelos/companias-aereas/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://mx.wingie.com/en/flights/to-mexico-city/',
                    title: 'Mexico City',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/to-cancun/',
                    title: 'Cancun',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://mx.wingie.com/en/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/ca-canada/',
                    title: 'Canada',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/co-colombia/',
                    title: 'Colombia',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/es-spain/',
                    title: 'Spain',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/aeromexico/',
                    title: 'Aeromexico',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/en/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://mx.wingie.com/de/flug/nach-mexiko-stadt/',
                    title: 'Mexiko-Stadt',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/nach-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/nach-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/nach-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/nach-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/nach-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://mx.wingie.com/de/flug/br-brazil/',
                    title: 'Brasilien',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/ca-kanada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/co-kolumbien/',
                    title: 'Kolumbien',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/es-spanien/',
                    title: 'Spanien',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/cu-kuba/',
                    title: 'Kuba',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/ar-argentinien/',
                    title: 'Argentinien',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/de/flug/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://mx.wingie.com/ru/flights/to-mexico-city/',
                    title: 'Мехико',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/to-guadalajara/',
                    title: 'Гвадалахара',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/to-monterrey/',
                    title: 'Монтеррей',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/to-tijuana/',
                    title: 'Тихуана',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/to-los-angeles/',
                    title: 'Лос-Анджелес',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://mx.wingie.com/ru/flights/br-brazil/',
                    title: 'Бразилия',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/co-colombia/',
                    title: 'Колумбия',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/es-spain/',
                    title: 'Испания',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/cu-cuba/',
                    title: 'Куба',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/ar-argentina/',
                    title: 'Аргентина',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/ru/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://mx.wingie.com/ar/flights/to-mexico-city/',
                    title: 'مدينة مكسيكو',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/to-cancun/',
                    title: 'كانكون',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/to-guadalajara/',
                    title: 'غوادالاخارا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/to-monterrey/',
                    title: 'مونتيري',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/to-tijuana/',
                    title: 'تيخوانا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/to-los-angeles/',
                    title: 'لوس أنجلوس',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://mx.wingie.com/ar/flights/br-brazil/',
                    title: 'البرازيل',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/ca-canada/',
                    title: 'كندا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/co-colombia/',
                    title: 'كولومبيا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/es-spain/',
                    title: 'إسبانيا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/cu-cuba/',
                    title: 'كوبا',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/ar-argentina/',
                    title: 'الأرجنتين',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/aeromexico/',
                    title: 'أيروميكسيكو',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/volaris/',
                    title: 'فولاريس',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/interjet/',
                    title: 'إنترجيت',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/vivaaerobus/',
                    title: 'فيفا أيروبوس',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/united-airlines/',
                    title: 'يونايتد إيرلاينز',
                },
                {
                    href: 'https://mx.wingie.com/ar/flights/airlines/american-airlines/',
                    title: 'أمريكان إيرلاينز',
                },
            ],
        },
    ],
    'mx-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://mx.wingie.com/it/flights/to-mexico-city/',
                    title: 'Città del Messico',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://mx.wingie.com/it/flights/br-brazil/',
                    title: 'Brasile',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/ca-canada/',
                    title: 'Canada',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/co-colombia/',
                    title: 'Colombia',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/es-spain/',
                    title: 'Spagna',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/it/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://mx.wingie.com/fr/flights/to-mexico-city/',
                    title: 'Mexico',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://mx.wingie.com/fr/flights/br-brazil/',
                    title: 'Brésil',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/ca-canada/',
                    title: 'Canada',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/co-colombia/',
                    title: 'Colombie',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/es-spain/',
                    title: 'Espagne',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/ar-argentina/',
                    title: 'Argentine',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/fr/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://mx.wingie.com/pt/flights/to-mexico-city/',
                    title: 'Cidade do México',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://mx.wingie.com/pt/flights/br-brazil/',
                    title: 'Brasil',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/ca-canada/',
                    title: 'Canadá',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/co-colombia/',
                    title: 'Colômbia',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/es-spain/',
                    title: 'Espanha',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/pt/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://mx.wingie.com/ro/flights/to-mexico-city/',
                    title: 'Orașul Mexico',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://mx.wingie.com/ro/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/ca-canada/',
                    title: 'Canada',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/co-colombia/',
                    title: 'Columbia',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/es-spain/',
                    title: 'Spania',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/ro/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://mx.wingie.com/pl/flights/to-mexico-city/',
                    title: 'Meksyk',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://mx.wingie.com/pl/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/ca-canada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/co-colombia/',
                    title: 'Kolumbia',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/es-spain/',
                    title: 'Hiszpania',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/cu-cuba/',
                    title: 'Kuba',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/ar-argentina/',
                    title: 'Argentyna',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/pl/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://mx.wingie.com/lt/flights/to-mexico-city/',
                    title: 'Meksiko miestas',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/to-cancun/',
                    title: 'Kankūnas',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/to-guadalajara/',
                    title: 'Gvadalachara',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/to-monterrey/',
                    title: 'Monterėjus',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/to-tijuana/',
                    title: 'Tichuana',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/to-los-angeles/',
                    title: 'Los Andželas',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://mx.wingie.com/lt/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/ca-canada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/co-colombia/',
                    title: 'Kolumbija',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/es-spain/',
                    title: 'Ispanija',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/cu-cuba/',
                    title: 'Kuba',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Populiarūs oro linijų bendrovės',
            items: [
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/lt/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://mx.wingie.com/uz/flights/to-mexico-city/',
                    title: 'Mexiko shahri',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/to-cancun/',
                    title: 'Kankun',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/to-guadalajara/',
                    title: 'Guadalaxara',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/to-tijuana/',
                    title: 'Tixuana',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/to-los-angeles/',
                    title: 'Los Anjeles',
                },
            ],
        },
        {
            title: 'Mashhur Mamlakatlar',
            items: [
                {
                    href: 'https://mx.wingie.com/uz/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/ca-canada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/co-colombia/',
                    title: 'Kolumbiya',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/es-spain/',
                    title: 'Ispaniya',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/cu-cuba/',
                    title: 'Kuba',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/ar-argentina/',
                    title: 'Argentina',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/uz/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-sr': [
        {
            title: 'Najčešće Destinacije',
            items: [
                {
                    href: 'https://mx.wingie.com/sr/flights/to-mexico-city/',
                    title: 'Мексико Сити',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/to-guadalajara/',
                    title: 'Гвадалахара',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/to-monterrey/',
                    title: 'Монтереј',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/to-tijuana/',
                    title: 'Тихуана',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/to-los-angeles/',
                    title: 'Лос Анђелес',
                },
            ],
        },
        {
            title: 'Популарне Земље',
            items: [
                {
                    href: 'https://mx.wingie.com/sr/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/co-colombia/',
                    title: 'Колумбија',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/es-spain/',
                    title: 'Шпанија',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/cu-cuba/',
                    title: 'Куба',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/ar-argentina/',
                    title: 'Аргентина',
                },
            ],
        },
        {
            title: 'Популарне Авиокомпаније',
            items: [
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/sr/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://mx.wingie.com/ky/flights/to-mexico-city/',
                    title: 'Мексико шаары',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/to-guadalajara/',
                    title: 'Гвадалахара',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/to-monterrey/',
                    title: 'Монтеррей',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/to-tijuana/',
                    title: 'Тихуана',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/to-los-angeles/',
                    title: 'Лос Анжелес',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://mx.wingie.com/ky/flights/br-brazil/',
                    title: 'Бразилия',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/co-colombia/',
                    title: 'Колумбия',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/es-spain/',
                    title: 'Испания',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/cu-cuba/',
                    title: 'Куба',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/ar-argentina/',
                    title: 'Аргентина',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/ky/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-tg': [
        {
            title: 'Беҳтарин шаҳрҳо',
            items: [
                {
                    href: 'https://mx.wingie.com/tg/flights/to-mexico-city/',
                    title: 'Шаҳри Мексико',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/to-guadalajara/',
                    title: 'Гвадалахара',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/to-monterrey/',
                    title: 'Монтерей',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/to-tijuana/',
                    title: 'Тихуана',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/to-los-angeles/',
                    title: 'Лос Анҷелес',
                },
            ],
        },
        {
            title: 'Кишварҳои маъмул',
            items: [
                {
                    href: 'https://mx.wingie.com/tg/flights/br-brazil/',
                    title: 'Бразилия',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/co-colombia/',
                    title: 'Колумбия',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/es-spain/',
                    title: 'Испания',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/cu-cuba/',
                    title: 'Куба',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/ar-argentina/',
                    title: 'Аргентина',
                },
            ],
        },
        {
            title: 'Ширкатҳои ҳавопаймоии маъмул',
            items: [
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/tg/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-kk': [
        {
            title: 'Ең танымал қалалар',
            items: [
                {
                    href: 'https://mx.wingie.com/kk/flights/to-mexico-city/',
                    title: 'Мексико қаласы',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/to-guadalajara/',
                    title: 'Гвадалахара',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/to-monterrey/',
                    title: 'Монтеррей',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/to-tijuana/',
                    title: 'Тихуана',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/to-los-angeles/',
                    title: 'Лос-Анжелес',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://mx.wingie.com/kk/flights/br-brazil/',
                    title: 'Бразилия',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/co-colombia/',
                    title: 'Колумбия',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/es-spain/',
                    title: 'Испания',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/cu-cuba/',
                    title: 'Куба',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/ar-argentina/',
                    title: 'Аргентина',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/kk/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://mx.wingie.com/nl/flights/to-mexico-city/',
                    title: 'Mexico-Stad',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/to-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/to-guadalajara/',
                    title: 'Guadalajara',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/to-monterrey/',
                    title: 'Monterrey',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/to-tijuana/',
                    title: 'Tijuana',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/to-los-angeles/',
                    title: 'Los Angeles',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://mx.wingie.com/nl/flights/br-brazil/',
                    title: 'Brazil',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/ca-canada/',
                    title: 'Canada',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/co-colombia/',
                    title: 'Colombia',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/es-spain/',
                    title: 'Spanje',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/cu-cuba/',
                    title: 'Cuba',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/ar-argentina/',
                    title: 'Argentinië',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/aeromexico/',
                    title: 'Aeroméxico',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/volaris/',
                    title: 'Volaris',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/interjet/',
                    title: 'Interjet',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/vivaaerobus/',
                    title: 'VivaAerobus',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://mx.wingie.com/nl/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
            ],
        },
    ],
    'mx-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://mx.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://mx.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://mx.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://mx.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://mx.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://mx.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://mx.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://mx.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://mx.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://mx.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://mx.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://mx.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://mx.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://mx.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://mx.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://mx.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://mx.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://mx.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://mx.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://mx.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://mx.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://mx.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://mx.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://mx.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://mx.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://mx.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://mx.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://mx.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://mx.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://mx.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://mx.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://mx.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://mx.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://mx.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://mx.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://mx.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://mx.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://mx.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://mx.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://mx.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://mx.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://mx.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://mx.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://mx.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://mx.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://mx.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://mx.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://mx.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://mx.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://mx.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://mx.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://mx.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://mx.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://mx.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://mx.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://mx.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://mx.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://mx.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://mx.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://mx.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://mx.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://mx.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://mx.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://mx.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://mx.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://mx.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://mx.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://mx.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://mx.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://mx.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://mx.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://mx.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://mx.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://mx.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://mx.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://mx.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://mx.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://mx.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://mx.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://mx.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://mx.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://mx.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://mx.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://mx.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://mx.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://mx.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://mx.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://mx.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://mx.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://mx.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://mx.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://mx.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://mx.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://mx.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://mx.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://mx.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://mx.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://mx.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://mx.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://mx.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://mx.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://mx.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://mx.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://mx.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://mx.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://mx.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://mx.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://mx.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://mx.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://mx.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://mx.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://mx.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://mx.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://mx.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://mx.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://mx.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://mx.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://mx.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://mx.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'mx-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://mx.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://mx.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://mx.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://mx.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://mx.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://mx.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://mx.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://mx.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://mx.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://mx.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://mx.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://mx.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://mx.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://mx.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://mx.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://mx.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://mx.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://mx.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}